import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './AppShell.module.css';

export interface AppShellProps {
  children: ReactNode;
}

/** Top-level frame for library pages (Home, adventure detail, runs). */
export function AppShell({ children }: AppShellProps) {
  return (
    <div className={styles.shell}>
      <header className={styles.topbar}>
        <Link to="/" className={styles.brand}>
          <span className={styles.brandIcon} aria-hidden>
            🕯️
          </span>
          GM Binder
        </Link>
        <nav className={styles.nav}>
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              [styles.navLink, isActive ? styles.navActive : undefined].filter(Boolean).join(' ')
            }
          >
            Il Tavolo
          </NavLink>
          <NavLink
            to="/groups"
            className={({ isActive }) =>
              [styles.navLink, isActive ? styles.navActive : undefined].filter(Boolean).join(' ')
            }
          >
            Gruppi
          </NavLink>
          <NavLink
            to="/library"
            className={({ isActive }) =>
              [styles.navLink, isActive ? styles.navActive : undefined].filter(Boolean).join(' ')
            }
          >
            Libreria
          </NavLink>
        </nav>
        <div className={styles.spacer} />
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
}
